export default {
  myAccount: 'My Account',
  pushCardToWithdraw: 'Push withdrawal card to withdraw',
  withdraw: 'Withdraw',
  getChance: 'Get draw chance',
  chance: 'Chances',
  drawNow: 'Draw',
  theNWithdraw: 'The <span class="amount">{sort}</span> Withdrawal',
  drawing: 'Drawing'
}
